import { useState } from "react";
import { DIRECCIONES_DATA } from "../data/DireccionesData";
import { useAuth } from "../context/AuthContext";
import WhatsappIcon from '../components/WhatsappIcon';

const CopyField = ({ label, value }) => (
  <div className="flex items-start justify-between bg-[#222222] rounded-xl px-4 py-3">
    <div>
      <p className="text-xs text-gray-400 uppercase tracking-wider">
        {label}
      </p>
      <p className="font-mono text-white">{value}</p>
    </div>
    <button
      onClick={() => navigator.clipboard.writeText(value)}
      className="text-lime-400 hover:text-white transition text-sm font-semibold"
    >
      Copiar
    </button>
  </div>
);

const ServiceCard = ({ title, data }) => (
  <div className="bg-[#292929] rounded-2xl p-6 space-y-4 border border-[#333]">
    <h3 className="text-2xl font-bold text-lime-400 mb-4">{title}</h3>

    {Object.entries(data).map(([key, value]) => (
      <CopyField key={key} label={key} value={value} />
    ))}
  </div>
);

export default function DatosDelPedido() {
  const [country, setCountry] = useState("usa");
  const { user } = useAuth();

  const countryData = DIRECCIONES_DATA[country];
  if (!countryData) return null;

  const servicios = countryData.servicios;

  const fullName = user?.nombre && user?.apellido
    ? `${user.nombre} ${user.apellido}`.toUpperCase()
    : "TU NOMBRE";

  return (
    <div className="min-h-screen bg-[#222222] text-white px-6 py-16">
      <div className="max-w-5xl mx-auto">
        {/* Asesoría */}
        <div className="bg-[#292929] border border-lime-400/30 rounded-2xl p-6 mb-12 text-center">
        
          <h2 className="text-xl sm:text-2xl font-bold text-lime-400 mb-2">
            ¿Primera vez comprando?
          </h2>
        
          <p className="text-gray-300 mb-6">
            Contacta a un asesor que te guiará paso a paso durante todo el proceso.
          </p>
        
          <a
            href="https://api.whatsapp.com/send/?phone=593982968185&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="
              inline-flex items-center gap-2 sm:gap-3
              bg-lime-400 text-black font-bold uppercase
              text-sm sm:text-base
              py-3
              px-8
              rounded-full
              hover:bg-white hover:text-lime-400
              transition-colors duration-300
            "
          >
            <WhatsappIcon className="w-5 h-5 sm:w-6 sm:h-6" />
            <span>Chatea aquí</span>
          </a>
        
        </div>

        <h1 className="text-5xl font-bold text-lime-400 text-center mb-4">
          Datos de envío
        </h1>

        <p className="text-center text-gray-400 mb-12">
          Copia estos datos y úsalos al momento de realizar tu compra
        </p>

        {/* Selector País */}
        <div className="flex justify-center gap-4 mb-12">
          {[
            { id: "china", label: "🇨🇳 China" },
            { id: "usa", label: "🇺🇸 USA" },
            { id: "espana", label: "🇪🇸 España" },
          ].map((c) => (
            <button
              key={c.id}
              onClick={() => setCountry(c.id)}
              className={`px-6 py-2 rounded-full font-semibold transition ${
                country === c.id
                  ? "bg-lime-400 text-black"
                  : "bg-[#292929] text-gray-300 hover:bg-[#333]"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        {/* Servicios */}
        <div className="grid md:grid-cols-2 gap-8">
          {servicios.map((servicio) => {
            let data = servicio.datos;

            // 🔥 SOLO KIFLIX tiene nombre dinámico
            if (servicio.id === "kiflix") {
              data = {
                nombre: `${fullName} + ${data.codigo}`,
                ...data,
              };
            }

            return (
              <ServiceCard
                key={servicio.id}
                title={servicio.titulo}
                data={data}
              />
            );
          })}
        </div>

      </div>
    </div>
  );
}



